import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const APIDef_AvatarMode = {
    getAllEncounters: { method: HttpMethod.GET, path: 'avatar-module/get-all-encounters', timeout: Minute },
    getAvatarLaunchJwt: { method: HttpMethod.GET, path: 'avatar-module/get-avatar-launch-jwt', timeout: Minute }
};
//# sourceMappingURL=api-def.js.map